export const cookies = {
    consent: {
        headline: 'Nous utilisons des cookies',
        declaration:
            "Nous utilisons des cookies sur notre site web. Certains d'entre eux sont essentiels, tandis que d'autres nous aident à améliorer votre expérience sur ce site web.",
        acceptEssential: 'Essentiels',
        acceptMarketing: 'Marketing',
        acceptStatistics: 'Statistiques',
        save: 'Sauvegarder les préférences',
        acceptAll: 'Tout accepter',
        revoke: 'Tout refuser',
    },
};
